var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrainHistory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 14,
    viewBox: "0 0 64 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearHistory",
    x1: 31.5844,
    y1: 1.89583,
    x2: 31.6356,
    y2: 14.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3DB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260313,
    stopColor: "#2345CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#355AEE"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9962 0H36.0077H27.9923H18.0038H3.87694C1.91446 0 0.48045 1.85319 0.972952 3.75287L3.04699 11.7529C3.39002 13.076 4.5841 14 5.95099 14H18.0038H31.6219H32.3781H45.9962H58.049C59.4159 14 60.61 13.076 60.953 11.7529L63.0271 3.75288C63.5196 1.8532 62.0855 0 60.1231 0H45.9962Z",
    fill: "url(#linearHistory) rgba(53,90,238,1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainHistory);
export default __webpack_public_path__ + "static/media/trainHistory.8bda0acb.svg";
export { ForwardRef as ReactComponent };